import { get, set, isEmpty, isPlainObject } from 'lodash-es';
import { sanitizeString, sanitizeIds } from './../../helpers/sanitize';
import clone from 'clone';
function getFirst(tryNames, value, defaultResult = '') {
    let result = defaultResult;
    for (let i = 0; i < tryNames.length; i++) {
        const tryName = tryNames[i];
        if (get(value, tryName, null)) {
            result = get(value, tryName);
            break;
        }
    }
    return sanitizeString(result);
}
export function getSelectOptionFromValue(value) {
    const id = get(value, 'id', null);
    if (!id) {
        return;
    }
    let label = getFirst(['react_select_label', 'full_name', 'name', 'title'], value, id);
    const htmlLabel = getFirst(['react_select_html_label'], value);
    return {
        value: `${id}`,
        label: `${label}`,
        html_label: `${htmlLabel}`,
    };
}
export const getInitialFormOptionsFromData = (data) => {
    const allInitialOptions = {};
    Object.keys(data).forEach((key) => {
        const thisInitialOptions = {};
        let values = data[key];
        if (!Array.isArray(values)) {
            values = [values];
        }
        for (let i = 0; i < values.length; i++) {
            const value = values[i];
            if (isPlainObject(value)) {
                const nestedInitialOptions = getInitialFormOptionsFromData(value);
                if (!isEmpty(nestedInitialOptions)) {
                    Object.assign(thisInitialOptions, nestedInitialOptions);
                }
            }
        }
        const initialOptions = [];
        for (let i = 0; i < values.length; i++) {
            const value = values[i];
            const option = getSelectOptionFromValue(value);
            if (!isEmpty(option)) {
                initialOptions.push(option);
            }
        }
        if (!isEmpty(initialOptions)) {
            thisInitialOptions.payload = initialOptions;
        }
        if (!isEmpty(thisInitialOptions)) {
            allInitialOptions[key] = thisInitialOptions;
        }
    });
    return allInitialOptions;
};
export const asignInitialFormIdsFromData = (rawData) => {
    const data = clone(rawData);
    Object.keys(data).forEach((key) => {
        let value = data[key];
        if (isPlainObject(value)) {
            set(data, key, asignInitialFormIdsFromData(value));
            return;
        }
        if (!Array.isArray(value)) {
            return;
        }
        if (null === get(value[0], 'id', null) ||
            null === get(value[0], 'name', null) ||
            null !== get(value[0], 'uid', null)) {
            return;
        }
        set(data, key, sanitizeIds(value));
    });
    return data;
};
export function checked(value = null) {
    return ['on', true, 'true', 1, '1', 'ja'].includes(value);
}
